import { Box, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { Loader, Modal } from '../../../../../components';
import { IEmailDetails } from '../../../../../models';
import { formatDate } from '../../../../../helpers';

interface IViewSentEmail {
  emailPreviewDetails: IEmailDetails;
  open: boolean;
  onClose: () => void;
  isLoadingEmailPreview: boolean;
}

export const ViewSentEmail: FC<IViewSentEmail> = ({
  emailPreviewDetails,
  onClose,
  open,
  isLoadingEmailPreview
}) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal open={open} title={emailPreviewDetails?.contactType} maxWidth="md" onClose={handleClose}>
      {isLoadingEmailPreview && <Loader type="overlay" position="centered" />}
      {!isLoadingEmailPreview && (
        <Box mt={1}>
          <Stack gap={1}>
            <Typography variant="body1">
              <span style={{ fontWeight: 'bold' }}>Subject:</span> {emailPreviewDetails?.subject}
            </Typography>
            <Typography variant="body1">
              <span style={{ fontWeight: 'bold' }}>Sent By:</span> {emailPreviewDetails?.sentBy} on{' '}
              {formatDate(emailPreviewDetails?.sentDate)}
            </Typography>
            <Typography variant="body1">
              <span style={{ fontWeight: 'bold' }}>Recipients:</span>{' '}
              {emailPreviewDetails?.recipientDisplay}
            </Typography>
            <Typography variant="body1">
              <span style={{ fontWeight: 'bold' }}>Message:</span>
            </Typography>
            <Typography
              variant="body1"
              dangerouslySetInnerHTML={{ __html: emailPreviewDetails?.body ?? '' }}
            ></Typography>
          </Stack>
        </Box>
      )}
    </Modal>
  );
};
